import QuestionOpenAnswerComponent from './containers/questionOpenAnswerComponent'

export { default as QuestionOpenAnswerLayout } from './components/questionOpenAnswerLayout' 

export default QuestionOpenAnswerComponent